export default __webpack_public_path__ + "static/media/cameraIconCompany.415bdfa5.svg";